<template>
    <div class="app mx-auto container">
      <NavBar class="shadow-xl" :menu="menu">Jaaki<span class="text-orange-500">T</span></NavBar>
      <Card class="sm:mt-0 md:mt-5 lg:mt-10">
        <router-view />
      </Card>
      <Footer class="sm:mt-0 md:mt-5 lg:mt-10 rounded"/>
    </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue"
import Card from "@/components/Card.vue";

export default {
  components: {
    NavBar,
    Footer,
    Card
  },
  data() {
    return {
      menu: [
        {
          ref: "/about",
          name: "about"
        },
        {
          ref: "/services",
          name: "services"
        },
        {
          ref: "/projects",
          name: "projects"
        },
        {
          ref: "/contact",
          name: "contact"
        }
      ]
    };
  }
};
</script>

<style lang="less">
.app {
   font-family: 'Baloo 2', cursive;

  //font-family: 'Balsamiq Sans', cursive;

  //font-family: "Nunito", sans-serif;

  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
